import { Component, Host, Prop, h, Event, EventEmitter, Method } from '@stencil/core';
import '@shoelace-style/shoelace/dist/components/checkbox/checkbox.js';

@Component({
  tag: 'jump-filter-checkbox',
  styleUrl: 'jump-filter-checkbox.scss',
  shadow: true,
})
export class JumpFilterCheckbox {

  @Prop() value: string;
  @Prop() label: string;
  @Prop({ reflect: true }) checked: boolean = false;
  @Prop() count: number | string = null;

  host: HTMLElement;
  el: HTMLElement;

  componentDidLoad() {
    this.listenSLChange();
  }

  listenSLChange() {
    if (this.host) {
      this.host.addEventListener('sl-change', () => {
        //invert the checked value
        this.checked = !this.checked;
        this.toggleCheckbox.emit({
          //@ts-ignore
          value: this.el.value,
          //@ts-ignore
          checked: this.checked,
        });
      });
    }
  }

  @Event({ eventName: 'jump-checkbox-change' }) toggleCheckbox: EventEmitter;

  @Method()
  async isChecked() {
    // @ts-ignore
    return this.el.checked;
  }

  render() {
    return (
      <Host ref={(host: HTMLElement) => this.host = host}>
        {this.value && this.label &&
          <sl-checkbox value={this.value} ref={(el: HTMLElement) => this.el = el}
            checked={this.checked}>
            {this.label}
          </sl-checkbox>}
        {this.count && <span class="count">{this.count}</span>}
      </Host>
    );
  }
}
